import { writable } from 'svelte/store';

// export const fonts = ["calibribold.ttf", "times.ttf", "impact.ttf", "calibri.ttf"];

// TODO use this
export const base_url = writable("https://cdn.nathanferns.xyz/memes/whatwhat?image=https://cdn.discordapp.com/attachments/616149431124885520/902778550267047966/unknown.png&top=welcome_to_the&bottom=editor");
export const layersInfo = writable([
    {
        id: "base",
        type: "image",
        position: [0, 0],
        dimensions: [0, 0],
        rotation: 0.0,
        transformations: [[0,0], [0,0], [0,0], [0,0]],
        font: "calibribold.ttf",
        stroke_width: 0,
        stroke_color: [0,0,0],
        align: "center",
        v_align: "center"
    }
]);
export const layers = writable([{name: 'layer 1', type: 'image', content: ''}]);
